import React from 'react'
import SettingTemplate from "../../../reusableComponent/SettingTemplate"

const TicketTemplate = () => {
  return (
    <div>
      <SettingTemplate title="Ticket"/>

    </div>
  )
}

export default TicketTemplate